function hasWindow() {
  return typeof window !== "undefined";
}
export {
  hasWindow
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
